var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrashSmallGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4447_16402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3H5.25V1.5C5.25 1.10218 5.40804 0.720644 5.68934 0.43934C5.97065 0.158035 6.35218 0 6.75 0L11.25 0C11.6478 0 12.0294 0.158035 12.3107 0.43934C12.592 0.720644 12.75 1.10218 12.75 1.5V3H16.5V4.5H15V15.75C15 16.3467 14.7629 16.919 14.341 17.341C13.919 17.7629 13.3467 18 12.75 18H5.25C4.65326 18 4.08097 17.7629 3.65901 17.341C3.23705 16.919 3 16.3467 3 15.75V4.5H1.5V3ZM11.25 1.5H6.75V3H11.25V1.5ZM4.5 15.75C4.5 15.9489 4.57902 16.1397 4.71967 16.2803C4.86032 16.421 5.05109 16.5 5.25 16.5H12.75C12.9489 16.5 13.1397 16.421 13.2803 16.2803C13.421 16.1397 13.5 15.9489 13.5 15.75V4.5H4.5V15.75Z",
    fill: "#00BC92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 7.5H11.25V13.5H9.75V7.5Z",
    fill: "#00BC92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74999 7.5H8.25V13.5H6.74999V7.5Z",
    fill: "#00BC92"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4447_16402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "matrix(-1 0 0 1 18 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashSmallGreen);
export default __webpack_public_path__ + "static/media/trashSmall-green.1bcec1fd516f05ff7d4fe8d8cd74eab4.svg";
export { ForwardRef as ReactComponent };